<!-- LOADING -->
<ng-container *ngIf="isLoading()">
  <div class="flex-1 flex items-center justify-center">
    <svg class="w-10 h-10 animate-spin text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="12" cy="12" r="10" opacity="0.25" />
      <path d="M22 12a10 10 0 0 1-10 10" />
    </svg>
  </div>
</ng-container>

<!-- ERROR -->
<ng-container *ngIf="!isLoading() && (error || !project)">
  <div class="flex-1 flex flex-col items-center justify-center gap-4">
    <h1 class="text-2xl font-bold">Project Not Found</h1>
    <a routerLink="/projects">
      <app-button>Back to Projects</app-button>
    </a>
  </div>
</ng-container>

<!-- CONTENT -->
<ng-container *ngIf="!isLoading() && project">
  <article class="flex-1 pb-20">

    <!-- HERO -->
    <div class="bg-secondary/20 border-b border-border">
      <div class="container mx-auto px-4 py-12 md:py-20">
        <a routerLink="/projects" class="inline-flex items-center text-muted-foreground hover:text-primary mb-8 transition-colors">
          ← Back to Projects
        </a>

        <h1 class="text-4xl md:text-6xl font-display font-bold mb-6">
          {{ project.title }}
        </h1>

        <p class="text-xl md:text-2xl text-muted-foreground max-w-3xl mb-8">
          {{ project.summary }}
        </p>

        <div class="flex flex-wrap gap-4">
          <a *ngIf="project.githubUrl" [href]="project.githubUrl" target="_blank">
            <app-button class="gap-2 bg-foreground text-background">
              Overview Link
            </app-button>
          </a>

          <a *ngIf="project.demoUrl" [href]="project.demoUrl" target="_blank">
            <app-button variant="outline" class="gap-2">
              Live Demo
            </app-button>
          </a>
        </div>
      </div>
    </div>

    <!-- BODY -->
    <div class="container mx-auto px-4 py-12 grid grid-cols-1 lg:grid-cols-3 gap-12">

      <!-- MAIN -->
      <div class="lg:col-span-2 space-y-8">

        <!-- MEDIA -->
        <div class="rounded-2xl overflow-hidden border border-border bg-card shadow-lg">
          <ng-container *ngIf="project.videoUrl; else imageBlock">
            <div class="aspect-video">
              <iframe [src]="project.videoUrl" class="w-full h-full" [title]="project.title" allowfullscreen></iframe>
            </div>
          </ng-container>

<ng-template #imageBlock>
  <div class="flex justify-center bg-secondary/10"> 
    <img *ngIf="project.imageUrl" 
         [src]="project.imageUrl" 
         [alt]="project.title" 
         class="w-auto h-auto max-w-full max-h-[600px] shadow-sm" />
  </div>
</ng-template>
        </div>

        <!-- MARKDOWN -->
        <div class="prose prose-lg dark:prose-invert max-w-none prose-headings:font-display prose-a:text-primary">
          <div class="prose lg:prose-xl">{{ project.content }}</div>
        </div>
      </div>

      <!-- SIDEBAR -->
      <aside class="space-y-8">
        <div class="p-6 rounded-2xl bg-card border border-border sticky top-24">
          <h3 class="font-bold text-lg mb-6">Project Details</h3>

          <!-- TAGS -->
          <div class="mb-6">
            <h4 class="text-sm uppercase text-muted-foreground mb-2">
              Technologies
            </h4>
            <div class="flex flex-wrap gap-2">
              <app-badge *ngFor="let tag of project.tags" variant="secondary">
                {{ tag }}
              </app-badge>
            </div>
          </div>

          <!-- DATE -->
          <div *ngIf="project.createdAt" class="mb-6">
            <h4 class="text-sm uppercase text-muted-foreground mb-2">
              Created
            </h4>
            <div class="text-sm">
              {{ project.createdAt | date }}
            </div>
          </div>

          <!-- CTA -->
          <!-- <div class="pt-6 border-t border-border">
            <h4 class="font-bold mb-2">Need a similar project?</h4>
            <p class="text-sm text-muted-foreground mb-4">
              I'm available for freelance work and consulting.
            </p>
            <app-button class="w-full" variant="secondary">
              Contact Me
            </app-button>
          </div> -->

        </div>
      </aside>
    </div>
  </article>
</ng-container>